import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { VOLOP_SOURCES } from '#/utils/constants/general/volopSources';

export function volopSourceFacet(i18n: I18nFn) {
  return {
    id: 'volopSourceFacet',
    name: 'source',
    get title() {
      return i18n('Source');
    },
    type: 'array',
    options: Object.keys(VOLOP_SOURCES),
    optionTitles: VOLOP_SOURCES,
  } as const satisfies SearchFacetData;
}
